import { render, staticRenderFns } from "./DispatchAttachTable.vue?vue&type=template&id=1fc04cce&scoped=true&"
import script from "./DispatchAttachTable.vue?vue&type=script&lang=js&"
export * from "./DispatchAttachTable.vue?vue&type=script&lang=js&"
import style0 from "./DispatchAttachTable.vue?vue&type=style&index=0&id=1fc04cce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc04cce",
  null
  
)

export default component.exports